import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronLeft, Edit, Heart, LogIn, MessageCircle, Paperclip, Send, Smile, Trash, X, XSquare } from "react-feather";
import Spinner, { LoadingThreeCircle } from "../../../global-components/src/components/spinner/spiner";
import { LIMIT_REQUEST_COMMENTS, LIMIT_TEXT_COMMENT } from "../../../utils/vars";
import { useAuth } from "../../../global-components/src";
import axios from "axios";
import { Post as PostType, Comment } from "../../../types";
import { calculateTime, errorMessage } from "../../../utils/TextManagerTwo";
import { useAiMentionLimitBanner } from "../../../hooks/useAiMentionLimit";
import AiLimitBanner from "../../ai-limit-banner";
import { useMessage } from "../../../global-components/src";
import ImgVerified from "../../imgVerified/ImgVerified";
import FormVerifyEmail from "../../FormVerifyEmail/FormVerifyEmail";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../../global-components/src/utils/vars";
import { getImageUser, getImageUserNotFound, hasPosition } from "../../../global-components/src/utils/auth";
import BottomSheet from "../../bottom-sheet/bottom-sheet";
import { CommentsPlaceholder } from "./comments-placeholder";
import { getAppVersion, getNativeKeyboardHeight, getNativeNavigationHeight, getPlatform, isIOSWebView, isNewApp, isNewAppAndroid } from "../../../utils/platform";
import PreviewSearch from "../../../pages/Settings/SearchScreen/preview-search";
import { Camera, Images, Laugh } from "lucide-react";
import { PostLinkPreview } from "../../Post/Post/post-link-preview";
import { YoutubePreview } from "../../Post/Post/youtube-preview";
import { calculateTimeReduce, censorText, clearText, extractFirstUrl, extractYouTubeId, isValidGifUrl, verifyLinks } from "../../../global-components/src/utils/text";
import { LinkPreview } from "../../Post/Post/link-preview";
import { Frame } from "../../Post/ImgProfilePost/frame";
import EmojiPickerNative from "../../Textarea/Emojis/emoji-picker-native";
import ReactPlayer from "react-player";
import { getImagePathBucketPacoca } from "../../../global-components/src/utils/utils";
import { compressImage, convertHeic } from "../../../global-components/src/utils/file";
import { useThemeEffects } from "../../../hooks/useThemeEffects";
import PinComment from "../../Post/Config/PinComment";
import AnchoredDropdown, { DropdownItem } from "../../AnchoredDropdown/AnchoredDropdown";
import { useCommentEcho, CommentMutation } from "../../../hooks/useCommentEcho";
import { applyCommentMutation } from "../../../utils/comment-mutations";
import { renderTextWithPhoneMessageLinks } from '../../../utils/phone-message-links';

interface ModalCommentsPropsBottom {
    idPostSelected: number | null; // Define que posts é um array de Post
    idCommentSelectedParam?: number | null; // Define que posts é um array de Post
    setIdCommentSelectedParam: Dispatch<SetStateAction<number | null>>;
    open: boolean;
}
type getCommentsOrResponseType = "response" | "comment";

interface FilePreview {
    file: File;
    src: string;
    type?: string;
}

const ModalCommentsContent: React.FC<ModalCommentsPropsBottom> = ({ idPostSelected, open, idCommentSelectedParam = null, setIdCommentSelectedParam }) => {
    const { id: postId } = useParams();
    const [likes, setLikes] = useState<any[]>([]);
    const [offset, setOffset] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [idPost, setIdPost] = useState<number | null>(idPostSelected);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [isLoadingPost, setIsLoadingPost] = useState(false);
    const { token, user, isAuthenticated } = useAuth();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const modalRef = useRef<HTMLDivElement | null>(null);
    const formRef = useRef<HTMLFormElement | null>(null);
    const [post, setPost] = useState<PostType>();
    const [comments, setComments] = useState<any[]>([]);
    const [pinnedCommentIds, setPinnedCommentIds] = useState<number[]>([]);
    const [expandedComments, setExpandedComments] = useState<{ [key: number]: boolean }>({});
    const [isLoadingResponse, setIsLoadingResponse] = useState<number | null>(null);
    const [responsesOffset, setResponsesOffset] = useState<{ [key: number]: number }>({});
    const [text, setText] = useState("");
    const aiLimitBannerName = useAiMentionLimitBanner(text, user?.id);
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [disabled, setDisabled] = useState(true);
    const [isEdditing, setIsEdditing] = useState(false);
    const [idCommentEdit, setIdCommentEdit] = useState(0);
    const [idCommentToResponse, setIdCommentToResponse] = useState<number | null>(null);
    const [idCommentSelected, setIdCommentSelected] = useState<number | null>(idCommentSelectedParam);
    const [commentSelected, setCommentSelected] = useState<Comment | null>(null);
    const [error404, setError404] = useState<string | null>(null);
    const { setMessage } = useMessage();
    const [isLimitExceeded, setIsLimitExceeded] = useState(false);
    const minHeight = 20; // Altura mínima inicial
    const [userNameCommentToResponse, setUserNameCommentToResponse] = useState<string | null>(null);
    const buttonRef = useRef<HTMLDivElement | null>(null);
    const closeModalRef = useRef<HTMLButtonElement | null>(null);
    const [selectedFiles, setSelectedFiles] = useState<FilePreview[]>([]);
    const audioInputRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();
    const [isFocusText, setIsFocusText] = useState(false);
    // const { checkAndTrigger } = useCopaEffect();
    const { checkAndTrigger } = useThemeEffects();
    const location = useLocation();
    const bodyRef = useRef<HTMLDivElement>(null);
    const isFirst = useRef(false);
    const [bottomPadding, setBottomPadding] = useState(5);
    const [textareaHeight, setTextareaHeight] = useState(30);
    const [showEmoji, setShowEmoji] = useState(false);
    const fileInputRefComment = useRef<HTMLInputElement>(null);
    const [audioUrl, setAudioUrl] = useState<string | null>(null);
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [orientation, setOrientation] = useState<("square" | "horizontal")[]>([]);
    const placeholderText = idCommentToResponse ? `Responder @${userNameCommentToResponse}` : (isEdditing ? "Editar comentário" : "Adicionar comentário");


    useCommentEcho({
        token,
        postId: idPostSelected,
        onComment: (mutation: CommentMutation) => {
            setComments(previous => applyCommentMutation(previous, mutation));
        },
    });
    
    const handleMediaChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (!files || !files.length) return;

        const selected = Array.from(files);
        const processed: File[] = [];

        for (let file of selected) {
            file = await convertHeic(file); 
            file = await compressImage(file);
            processed.push(file);
        }

        setSelectedFiles(prev => {
            let imageCount = prev.filter(f => f.type === "image").length;
            let hasVideo = prev.some(f => f.type === "video");

            const result = [...prev];

            for (const file of processed) {
                const isImage =
                    file.type.startsWith("image/") ||
                    /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name);

                const isVideo = file.type.startsWith("video/");

                if (isImage) {
                    if (imageCount >= 5) continue;

                    result.push({
                        file,
                        src: URL.createObjectURL(file),
                        type: "image",
                    });

                    imageCount++;
                }

                if (isVideo) {
                    if (hasVideo) continue;

                    result.push({
                        file,
                        src: URL.createObjectURL(file),
                        type: "video",
                    });

                    hasVideo = true;
                }
            }

            return result;
        });

        // reset input
        setTimeout(() => {
            if (event.target) event.target.value = "";
        }, 0);
    };


    const handleFile = async(file: any) => {
        file = await convertHeic(file); 
        file = await compressImage(file);
        const type = file.type;
        const dataTransfer = new DataTransfer(); 
    
        if (type.startsWith("image/") && fileInputRefComment.current?.files) {
            dataTransfer.items.add(file);
            fileInputRefComment.current.files = dataTransfer.files;
        
            const reader = new FileReader();
            reader.onload = (e) => {
                const src = e.target?.result;
                if (typeof src === "string") {
                    // cria um novo array baseado no estado atual
                    const newFiles = [...selectedFiles, { file, src, type: "image" }];
                    setSelectedFiles(newFiles);
                }
            };
            reader.readAsDataURL(file);

        }
            else if (type.startsWith("video/") && fileInputRefComment.current) {
            // remove vídeo anterior, se houver
            const filtered = selectedFiles.filter(f => f.type !== "video");

            // adiciona só o novo vídeo
            dataTransfer.items.add(file);
            fileInputRefComment.current.files = dataTransfer.files;

            const url = URL.createObjectURL(file);
            setSelectedFiles([...filtered, { file, src: url, type: "video" }]);
        } else if (type.startsWith("audio/") && audioInputRef.current) {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            audioInputRef.current.files = dataTransfer.files;
            const url = URL.createObjectURL(file);
            setAudioUrl(url);
        }
    };
    
    const handleDrop = (e: any) => {
        e.preventDefault();
        if (e.dataTransfer?.files && e.dataTransfer.files.length > 0) {
            Array.from(e.dataTransfer.files).forEach(file => handleFile(file));
        }
    };

    useEffect(() => {
        const modal = modalRef?.current;
        const form = formRef?.current;
        const root = document.documentElement;

        if (!modal || !form || !formRef) return;

        const handleDragOver = (event: DragEvent) => {
            event.preventDefault();
            event.stopPropagation();
            if(root.classList.contains("dark"))
                modal.style.setProperty("border", "2px dashed #fff", "important");
            else
                modal.style.setProperty("border", "2px dashed #000", "important");
        };

        const handleDragLeave = (event: DragEvent) => {
            event.preventDefault();
            event.stopPropagation();
            modal.style.border = "none";
        };

        const handleDropLocal = (event: DragEvent) => {
            event.preventDefault();
            modal.style.border = "none";
            handleDrop(event)
        };

        form.addEventListener("dragover", handleDragOver);
        form.addEventListener("dragleave", handleDragLeave);
        form.addEventListener("drop", handleDropLocal);

        return () => {
            form.removeEventListener("dragover", handleDragOver);
            form.removeEventListener("dragleave", handleDragLeave);
            form.removeEventListener("drop", handleDropLocal);
        };
    }, []);
    
    const handlePaste = (e: any) => {
        if (e.clipboardData.files && e.clipboardData.files.length > 0) {
            Array.from(e.clipboardData.files).forEach(file => handleFile(file));
        }
    };

    useEffect(() => {
        const el = bodyRef.current;
        if (!el) return;

        const handleScroll = () => {
            const { scrollTop, scrollHeight, clientHeight } = el;

            // Quando chega no final (ou perto dele)
            if ((scrollTop + clientHeight >= scrollHeight) && hasMore) {
                setOffset((prevOffset) => prevOffset + 1);
            }
        };

        el.addEventListener("scroll", handleScroll);

        return () => {
            el.removeEventListener("scroll", handleScroll);
        };
    }, [idPostSelected]);
    
    useEffect(() => {
        setIdCommentSelected(idCommentSelectedParam);
        if(idCommentSelectedParam){
            loadCommentSelected(idCommentSelectedParam)
        }
    }, [idCommentSelectedParam])
    

    useEffect(() => {
        closeModalRef.current?.click();
    }, [location.pathname]); // Executa toda vez que a URL muda

    const toggleCommentExpansion = (commentId: number) => {
        setIsLoadingResponse(commentId)
        loadResponses(commentId)

        setExpandedComments(prev => ({
            ...prev,
            [commentId]: !prev[commentId]
        }));
    };

    useEffect(() => {
        const handleKeyboardHeightChange = () => {
            const heightKeyboard = getNativeKeyboardHeight();
            const nativeNavigationHeight = getNativeNavigationHeight() ?? 0;
            let height = 30;
            if (textareaRef.current) height = textareaRef?.current.clientHeight;

            setBottomPadding(heightKeyboard ? (heightKeyboard + nativeNavigationHeight + 10) : (nativeNavigationHeight + 10));
        };

        window.addEventListener("keyboardHeightChange", handleKeyboardHeightChange);

        return () => {
            window.removeEventListener("keyboardHeightChange", handleKeyboardHeightChange);
        };
    }, []);

    
    function ajustaNewApp() {
        if((isNewApp() && isNewAppAndroid()) || isIOSWebView()){
            const nativeNavigationHeight = getNativeNavigationHeight();
            let height = 30;
            if (textareaRef.current) height = textareaRef?.current.clientHeight;

            if(nativeNavigationHeight && nativeNavigationHeight > 0){
                setBottomPadding(nativeNavigationHeight + 10);
            }

            window.addEventListener("navigationBarHeightChange", ajustaNewApp);
            return () => window.removeEventListener("navigationBarHeightChange", ajustaNewApp);
        }
    }
    useEffect(() => {
        ajustaNewApp()
    }, []);
    
    const handleInputTextarea = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newText = event.target.value;
        setText(newText);
        setIsLimitExceeded(newText.length > LIMIT_TEXT_COMMENT);
    }


    const handleBlurTextarea = () => {
        setIsFocusText(false);
        const menu = document.querySelector(".menu-cel-input") as HTMLElement;
        if (menu) menu.style.display = "block"; // Oculta o menu em vez de mostrá-lo
    };

    const updateText = (newText: string) => {
        setText(newText); // Atualiza o estado com o novo texto
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        const screenWidth = window.innerWidth;

        if (e.key === "Enter") {
            if (e.shiftKey || screenWidth <= 850) {
                e.preventDefault();

                const textarea = e.currentTarget;
                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;

                setText((prev) => {
                    const newText =
                        prev.substring(0, start) +
                        "\n" +
                        prev.substring(end);

                    // reposiciona o cursor após o React atualizar o estado
                    setTimeout(() => {
                        textarea.selectionStart = textarea.selectionEnd = start + 1;
                    }, 0);

                    return newText;
                });
            } else if (screenWidth > 850 && text.trim().length > 0) {
                e.preventDefault();
                handleSubmitComment(e as any);
            }
        }
    };

    const handleClickEmoji = () => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        setText((prev) => {
            if (prev[start - 1] === ":") return prev;

            const needsSpaceBefore =
                start > 0 && prev[start - 1] !== " " && prev[start - 1] !== "\n";

            const insertText = needsSpaceBefore ? " :" : ":";

            const newText =
                prev.substring(0, start) +
                insertText +
                prev.substring(end);

            setTimeout(() => {
                const pos = start + insertText.length;

                textarea.focus();
                textarea.selectionStart = textarea.selectionEnd = pos;

                // 🔥 SIMULA DIGITAÇÃO REAL
                textarea.dispatchEvent(new Event("input", { bubbles: true }));
            }, 0);

            return newText;
        });
    };

    useEffect(() => {
        if (selectedFiles.length > 0 || (text?.length < LIMIT_TEXT_COMMENT && text?.trim()?.length > 0)) setDisabled(false)
        else setDisabled(true)
    }, [text, selectedFiles]);

    const handleSubmitComment = async (event: any, textLocal = text, gifUrl?: string) => {
        if(event) event.preventDefault(); // Impede o envio do formulário
        setSelectedFiles([])
 
        if(gifUrl?.trim().length && !isValidGifUrl(gifUrl)){
            setMessage("GIF invalido", "error");
            return;
        }
 
        if(!textLocal.trim().length && !gifUrl?.trim().length && selectedFiles.length === 0){
            setMessage("Escreva um comentário, adicione um GIF ou selecione uma imagem", "error");
            return;
        }

        if(text.length > LIMIT_TEXT_COMMENT){
            setMessage(`O texto não pode passar de ${LIMIT_TEXT_COMMENT} caracteres`, "error");
            return;
        }

        if(textLocal && verifyLinks(textLocal)){
            setMessage("Link suspeito, você não pode realizar esse comentário", "error");
            setLoading(false);
            return;
        }

        checkAndTrigger(textLocal, "comment")
        // textareaRef.current?.blur();
        setDisabled(true);
        const isEdit = idCommentEdit && idCommentEdit > 0;
        const oldIdCommentEdit = idCommentEdit;

        const oldText = textLocal;
        var tempId = Date.now(); // ID temporário
        const newCommentData = {
            total_likes: 0,
            total_responses: 0,
            gif_url: isValidGifUrl(gifUrl) ? gifUrl : null,
            id_comment: idCommentToResponse || null, // ID temporário
            id: tempId, // ID temporário
            idNotSend: true,
            images: selectedFiles.map((media, index) => ({
                id: `temp-${tempId}-${index}`,
                path: media.src,
                type: media.type == "image" ? 0 : 1,
                isTemp: true
            })),
            user: {
                img_account: user?.img_account, // Imagem do usuário autenticado
                name: user?.name, // Nome do usuário
                user_name: user?.user_name, // Nome do usuário
                verified_profile: user?.verified_profile, // Nome do usuário
                stamps: user?.stamps, // Nome do usuário
                position: user?.position, // Nome do usuário
                id: user?.id, // Nome do usuário
            },
            textFormatted: textLocal, // Texto do comentário
            created_at: new Date().toISOString(), // Data do comentário
            can_edit: true, // Data do comentário
            can_delete: true, // Data do comentário
        };

        // Adiciona a resposta ao array `responses` do comentário correspondente
        if (idCommentToResponse && idCommentToResponse > 0) {
            setComments((prevComments) =>
                prevComments.map((comment) =>
                    comment.id === idCommentToResponse
                        ? {
                            ...comment,
                            total_responses: (comment.total_responses || 0) + 1,
                            responses: [newCommentData, ...(comment.responses || [])],
                        }
                        : comment
                )
            );
            setExpandedComments(prev => ({ ...prev, [idCommentToResponse]: true }));
        } else if (!isEdit) {
            // Se não for uma resposta, adiciona como um novo comentário
            setComments((prevComments) => [newCommentData, ...prevComments]);
        } else {
            // Se for uma edição, atualiza o comentário existente
            tempId = idCommentEdit
            setComments((prevComments) =>
                prevComments.map((comment) =>
                    comment.id === tempId ? { ...comment, id: idCommentEdit, textFormatted: textLocal, idNotSend: true, gif_url: isValidGifUrl(gifUrl) ? gifUrl : null } : comment
                )
            );
        }

        if(!idCommentSelected) cancelEdit()
        else setText("");

        try {
            const formData = new FormData();
            formData.append("comment", textLocal);
            if (gifUrl && isValidGifUrl(gifUrl)) formData.append("gif_url", gifUrl);

            if (idCommentToResponse && idCommentToResponse > 0)
                formData.append("id_original_comment", String(idCommentToResponse));

            selectedFiles.forEach(media => {
                if (media.type === "image") {
                    formData.append("img[]", media.file);
                }

                if (media.type === "video") {
                    formData.append("video", media.file);
                }
            });

            const audioFile = (document.getElementById("audio") as HTMLInputElement).files;
            if (audioFile && audioFile[0]) {
                formData.append("audio", audioFile[0]);
            }
            
            if (idCommentSelected && idCommentSelected > 0)
                formData.append("id_original_comment", String(idCommentSelected));

            const url = !isEdit ? (`${PACOCA_API_URL}/comments/${idPostSelected}`) : (`${PACOCA_API_URL}/comments/${idCommentEdit || idCommentSelected}`);
            var response: any;

            if (!isEdit) {
                response = await axios.post(url, formData, {
                    headers: {
                        "Accept": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                });
            } else {
                response = await axios.patch(url, {
                    id_comment: idCommentEdit, comment: textLocal, gif_url: isValidGifUrl(gifUrl) ? gifUrl : null
                }, {
                    headers: {
                        "Accept": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                });
            }

            // Atualiza o estado com o ID real da resposta
            if (idCommentToResponse) {
                setComments((prevComments) =>
                    prevComments.map((comment) =>
                        comment.id === idCommentToResponse
                            ? {
                                ...comment,
                                responses: comment.responses?.map((responseItem: { id: number; }) =>
                                    responseItem.id === tempId
                                        ? { ...responseItem, id: response?.data?.comment?.id, idNotSend: false }
                                        : responseItem
                                ),
                            }
                            : comment
                    )
                );
            } else {
                setComments((prevComments) =>
                    prevComments.map((comment) =>
                        comment.id === tempId ? { ...comment, id: response?.data?.comment?.id, idNotSend: false } : comment
                    )
                );
            }
        } catch (err: any) {
            textareaRef.current?.blur();
            // Se houver erro, remove o comentário temporário
            if (!isEdit) {
                setComments((prevComments) =>
                    prevComments
                        .filter((comment) => comment.id !== tempId)
                        .map((comment) =>
                            idCommentToResponse && comment.id === idCommentToResponse
                                ? {
                                    ...comment,
                                    total_responses: Math.max(0, (comment.total_responses || 0) - 1),
                                    responses: comment.responses?.filter((r: { id: number }) => r.id !== tempId),
                                  }
                                : comment
                        )
                );
                setText(oldText);
                setDisabled(false);
            }
            else {
                clickEdit(oldIdCommentEdit, oldText)
                setComments((prevComments) =>
                    prevComments.map((comment) =>
                        comment.id === tempId ? { ...comment, id: idCommentEdit, textFormatted: oldText, idNotSend: "error" } : comment
                    )
                );
            }

            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            setMessage(messageError, type)
            console.error('Erro:', err);
        }
    };

    const cancelEdit = () => {
        setIsEdditing(false);
        setText("");
        setIdCommentEdit(0);
        setIdCommentToResponse(null);
        setIdCommentSelected(null);
        setCommentSelected(null);
        setError404(null);
        idCommentSelectedParam = null;
    };

    const backComment = () => {
        isFirst.current = false;
        
        setIsEdditing(false)
        setText("")
        setIdCommentEdit(0)
        setIdCommentToResponse(null);
        setIdCommentSelected(null);
        setCommentSelected(null)
        // setOffset(0);
        setHasMore(true);
        setResponsesOffset({});
        setExpandedComments({});
        setError404(null);
        idCommentSelectedParam = null;
    };

useEffect(() => {
    const handleClick = (e: any) => {
        if (e.target.closest(".back-comment")) {
            backComment();
        }
    };

    document.addEventListener("click", handleClick);

    return () => {
        document.removeEventListener("click", handleClick);
    };
}, []);



    // useEffect(() => {
    //     const fetchData = async () => {
    //         // setOffset(0);
    //         // setHasMore(true);
    //         setResponsesOffset({});
    //         setExpandedComments({});
    //         setComments([]);
    //         setError404(null);
    //     };
    
    //     fetchData();

    //     // if (idCommentSelected || idCommentSelectedParam) {
    //     //     loadData("response", 0);
    //     // } else if (open) {
    //     //     loadData("comment", 0);
    //     // }
    // }, [idCommentSelected, idCommentSelectedParam, postId, open]);

    // useEffect(() => {
    //     if(!hasMore || !open) return;
        
    //     if(offset >= 1) loadData("comment");
    //     // if (idCommentSelected || idCommentSelectedParam) {
    //     //     loadData("response", 1);
    //     // } else if (open) {
    //     //     loadData("comment", 1);
    //     // }
    // }, [offset, idCommentSelected, idCommentSelectedParam, postId, open])


    useEffect(() => {
        const modalBody = document.getElementsByClassName("modal-body-likes")[0];

        const handleScroll = () => {
            if (!modalBody || !open) return;
            
            const { scrollTop, clientHeight, scrollHeight } = modalBody;

            if ((scrollTop + clientHeight >= scrollHeight - 50) && !isLoading && hasMore) {
                // setOffset((prevPage) => prevPage + 1); // Agora a página é atualizada antes da requisição
                // loadData("comment");
            }
        };

        if (modalBody) {
            modalBody.addEventListener("scroll", handleScroll);
            window.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (modalBody) {
                modalBody.removeEventListener("scroll", handleScroll);
                window.removeEventListener("scroll", handleScroll);
            }
        };
    }, [isLoading, open])

    useEffect(() => {
        // const fetchData = async () => {
        //     setOffset(0);
        //     setHasMore(true);
        //     setResponsesOffset({});
        //     setExpandedComments({});
        //     setComments([]);
        //     setError404(null);
        // };
    
        // fetchData();

        if (idCommentSelected || idCommentSelectedParam) {
            setIsLoading(true);
            loadData("response");
        } else if (open) {
            loadData("comment");
        }
    }, [idCommentSelected, idCommentSelectedParam, postId, open]);

    useEffect(() => {
         const fetchData = async () => {
            setOffset(1);
            setHasMore(true);
            setResponsesOffset({});
            setExpandedComments({});
            setComments([]);
            setError404(null);
        };
    
        fetchData();
    }, [idCommentSelected, idCommentSelectedParam, postId, open]);

    useEffect(() => {
        if(offset === 1) return;
        loadData("comment");
    }, [offset]);

    useEffect(() => {
        setIdCommentSelectedParam(idCommentSelected);
    }, [idCommentSelected])
    

    const clickEdit = (idComment: number, text: string) => {
        setIsEdditing(true)
        setText(text)
        setIdCommentEdit(idComment)
    }

    const handlePinToggle = (commentId: number, pinned: boolean) => {
        setPinnedCommentIds((prev) =>
            pinned ? [...prev, commentId] : prev.filter((id) => id !== commentId)
        );
        setComments((prev) =>
            prev.map((c) => c.id === commentId ? { ...c, is_pinned: pinned } : c)
        );
    };

    useEffect(() => {
        if(!open){
            setOffset(1);
            setIsEdditing(false);
            setText("");
            setIdCommentEdit(0);
            setIdCommentToResponse(null);
            setIdCommentSelected(null);
            setCommentSelected(null);
            setHasMore(true);
            setError404(null);
            setPinnedCommentIds([]);
            isFirst.current = false;
            // cancelEdit();
        }
    }, [open]);

    const loadResponses = async (commentId: number, offset: number = 0) => {
        const url = `${PACOCA_API_URL}/comments/responses/${commentId}?limit=${LIMIT_REQUEST_COMMENTS}&offset=${offset}`;

        try {
            const response = await axios.get(url, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            setComments(prevComments => prevComments.map(comment =>
                comment.id === commentId
                    ? {
                        ...comment,
                        responses: offset === 0
                            ? response.data.comments // Se for a primeira carga, substitui as respostas
                            : [...(comment.responses || []), ...response.data.comments], // Adiciona novas respostas
                    }
                    : comment
            ));

            // Atualiza o offset para o próximo carregamento
            setResponsesOffset(prev => ({
                ...prev,
                [commentId]: offset + LIMIT_REQUEST_COMMENTS,
            }));
        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            setMessage(messageError, type)
            console.error('Erro:', err);
        } finally {
            setIsLoadingResponse(null);
        }
    };

    const loadData = async (getCommentsOrResponse: getCommentsOrResponseType = "comment", thisOffset = offset) => {
        if (!idPostSelected && getCommentsOrResponse == "comment") return;
        if ((!hasMore && getCommentsOrResponse == "comment")) return;
        
        if(!isFirst.current) setIsLoading(true);
        setIsLoadingMore(true);
        isFirst.current = true;
        
        
        const url = getCommentsOrResponse == "comment"
            ? `${PACOCA_API_URL}/posts/comments/${idPostSelected}/?limit=${LIMIT_REQUEST_COMMENTS}&offset=${thisOffset}`
            : `${PACOCA_API_URL}/posts/comments/responses/${idCommentSelected || idCommentSelectedParam}/?limit=${LIMIT_REQUEST_COMMENTS}&offset=${thisOffset}`;
        try {
            
            const response = await axios.get(url, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

            const newComments: any[] = response.data.comments.map((c: any) =>
                c.first_reply ? { ...c, responses: [c.first_reply] } : c
            );

            setComments((prevData) => {
                const updatedComments = [...prevData, ...newComments];
                setHasMore(response.data.comments.length && (response.data.total_comments >= LIMIT_REQUEST_COMMENTS));
                return updatedComments;
            });

            // Expande automaticamente os comentários que já têm first_reply pré-carregado
            const withReply = newComments.filter((c: any) => c.first_reply);
            if (withReply.length > 0) {
                setExpandedComments(prev => {
                    const next = { ...prev };
                    withReply.forEach((c: any) => { next[c.id] = true; });
                    return next;
                });
                setResponsesOffset(prev => {
                    const next = { ...prev };
                    withReply.forEach((c: any) => { next[c.id] = 1; });
                    return next;
                });
            }

            if (thisOffset === 1 && response.data.pinned_comment_ids) {
                setPinnedCommentIds(response.data.pinned_comment_ids.map(Number));
            }
            
        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)

            if(err.status == 404){
                setError404(messageError);
                return;
            } else{
                setMessage(messageError, type)
            }
            
            console.error('Erro:', err);
        } finally {
            setIsLoading(false);
            setIsLoadingMore(false);
        }
    };

    const loadCommentSelected = async (idCommentSelected: number) => {
        const url = `${PACOCA_API_URL}/posts/comments/find/${idCommentSelected}`
        try {
            const response = await axios.get(url, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

            setCommentSelected(response.data);
        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err);

            if(err.status == 404){
                setError404(messageError);
                return;
            }

            setMessage(messageError, type)
            console.error('Erro:', err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const handleModalClose = () => {
            setComments([]);
            setIsLoading(false)
            // setOffset(0)
            setHasMore(true)
        };

        const modalElement = document.getElementById("modal-comments");
        if (modalElement) {
            modalElement.addEventListener("hidden.bs.modal", handleModalClose);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener("hidden.bs.modal", handleModalClose);
            }
        };
    }, []);

    const handleDelete = async (idComment: number, isResponse = false, parentCommentId?: number) => {
        const url = `${PACOCA_API_URL}/comments/${idComment}`;

        try {

            if (isResponse && parentCommentId) {
                // Se for uma resposta, remove dentro do responses do comentário pai
                setComments((prevData) =>
                    prevData.map(comment =>
                        comment.id === parentCommentId
                            ? {
                                ...comment,
                                responses: comment.responses.filter((response: { id: number; }) => response.id !== idComment),
                                total_responses: Math.max(0, comment.total_responses - 1) // Garante que não fique negativo
                            }
                            : comment
                    )
                );
            } else {
                // Se for um comentário normal, remove da lista de comments
                setComments((prevData) => prevData.filter(comment => comment.id !== idComment));
            }

            await axios.delete(url, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            setMessage(messageError, type)
            console.error('Erro:', err);
        }
    }

    const handleLike = async (idComment: number, isResponse = false, parentCommentId?: number) => {
        const url = `${PACOCA_API_URL}/comments/like/${idComment}`;

        try {
            setComments((prevComments) =>
                prevComments.map((comment) => {
                    if (isResponse && parentCommentId) {
                        // Se for uma resposta, encontra o comentário pai e atualiza a resposta específica
                        return comment.id === parentCommentId
                            ? {
                                ...comment,
                                responses: comment.responses.map((response: { id: number; is_liked: any; total_likes: number; }) =>
                                    response.id === idComment
                                        ? {
                                            ...response,
                                            is_liked: !response.is_liked,
                                            total_likes: response.is_liked
                                                ? Math.max(0, response.total_likes - 1) // Evita valores negativos
                                                : response.total_likes + 1,
                                        }
                                        : response
                                )
                            }
                            : comment;
                    } else {
                        // Se for um comentário principal, atualiza normalmente
                        return comment.id === idComment
                            ? {
                                ...comment,
                                is_liked: !comment.is_liked,
                                total_likes: comment.is_liked
                                    ? Math.max(0, comment.total_likes - 1) // Evita valores negativos
                                    : comment.total_likes + 1,
                            }
                            : comment;
                    }
                })
            );

            await axios.post(url, {}, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            setMessage(messageError, type)
            console.error('Erro:', err);
        }
    }

    const resizeTextarea = () => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const minHeight = 30; // mesma altura do rows={1}
        setTextareaHeight(minHeight);

        textarea.style.height = "auto";
        textarea.scrollTop = 0; // 🔑 limpa scroll antigo

        const scrollHeight = textarea.scrollHeight;

        const maxHeight = parseFloat(
            getComputedStyle(textarea).maxHeight || "0"
        );

        if (scrollHeight <= minHeight) {
            setTextareaHeight(minHeight);
            textarea.style.height = `${minHeight}px`;
            textarea.style.overflowY = "hidden";
            return;
        }

        if (maxHeight && scrollHeight > maxHeight) {
            setTextareaHeight(maxHeight);
            textarea.style.height = `${maxHeight}px`;
            textarea.style.overflowY = "auto";
        } else {
            setTextareaHeight(scrollHeight);
            textarea.style.height = `${scrollHeight}px`;
            textarea.style.overflowY = "hidden";
        }
    };

    useEffect(() => {
        resizeTextarea();
    }, [text]);

    const handleClickGif = (sticky: string) => {
        // const oldText = text;
        handleSubmitComment(null, text, sticky);
        // setText(oldText.slice(0, oldText.length - 1));
    }

    const handleRemoveMedia  = (index: number) => {
        setSelectedFiles(prev => {
            const file = prev[index];
            if (file?.src) URL.revokeObjectURL(file.src);

            return prev.filter((_, i) => i !== index);
        });
    };

    return (
        <>
            <div onDrop={handleDrop} onDragOver={(e) => e.preventDefault()} className="comments-modal-items modal-body modal-body-comments overflow-minus"  ref={bodyRef}>
                <div className="">
                    {commentSelected ? (
                        <div className="row card-comment-open" style={{ marginTop: "5px", background: "transparent", paddingTop: "10px", borderRadius: "10px", position: "relative" }}>
                            {commentSelected.can_edit || commentSelected.can_delete ? (
                                <div className="col-1 col-conf-post" style={{ position: "absolute", zIndex: 1 }}>
                                    <AnchoredDropdown>
                                        {commentSelected.can_edit ? (
                                            <DropdownItem icon={<Edit size={15} className="icon-config-post" />} onClick={() => clickEdit(commentSelected.id, commentSelected.textFormatted)}>
                                                Editar
                                            </DropdownItem>
                                        ) : null}
                                        {commentSelected.can_delete ? (
                                            <DropdownItem icon={<Trash size={15} className="icon-config-post" />} danger onClick={() => handleDelete(commentSelected.id, true, commentSelected.id_comment)}>
                                                Excluir
                                            </DropdownItem>
                                        ) : null}
                                    </AnchoredDropdown>
                                </div>
                            ) : null}


                            <img className="user-select-none col-1 img-account-likes img-account-comment" src={getImageUser(commentSelected?.user?.img_account)} onError={(e) => { e.currentTarget.src = getImageUserNotFound(commentSelected?.user.name); }} />
                            <div className="col col-comment-text">
                                <div className="comment-text">
                                    <div className="col-12 d-flex" style={{ gap: "5px", alignItems: "center", flexWrap: "wrap" }}>
                                        <Link className="name-comment user-name-view-comment" to={`/@${commentSelected?.user.user_name}`}>
                                            <h1 style={{ fontSize: "12.5px", marginBottom: 0 }}>
                                                <span>
                                                    {commentSelected?.user.name}
                                                    <ImgVerified user={user} classNameProp="img-verified-preview-comment user-select-none img-verificado-comentario" />
                                                </span>
                                            </h1>
                                        </Link>
                                        <div>
                                            <p className="date-comment date-comment-view-comment" style={{ marginBottom: 0 }}></p>
                                            <p className="username-comment username-view-comment w-100">@{commentSelected?.user.user_name}</p>
                                        </div>
                                    </div>
                                    {commentSelected.textFormatted && commentSelected.textFormatted !== commentSelected.gif_url && (
                                        <p dangerouslySetInnerHTML={{ __html: renderTextWithPhoneMessageLinks(censorText(commentSelected.textFormatted || ""), clearText) }} className="text-comment text-comment-view-comment cursor-pointer" />
                                    )}
                                    {commentSelected.gif_url && (
                                        <img
                                            src={commentSelected.gif_url}
                                            className="comment-gif"
                                            alt="GIF"
                                            style={{ marginTop: commentSelected.textFormatted?.trim().length ? 0 : 5 }}
                                        />
                                    )}
                                    {commentSelected.images && commentSelected.images.length > 0 && (
                                        <div className="comment-media" style={{ marginTop: commentSelected.textFormatted?.trim().length ? 0 : 5 }}>
                                            {commentSelected.images.map((media: any, index: number) => (
                                                <div key={media.id ?? index} className="comment-media-item">
                                                    {media.type == 0 ? (
                                                        <img
                                                            onError={(e) => (e.currentTarget.src = "/img/image_not_found.png?v=1")}
                                                            src={media.isTemp ? media.path : getImagePathBucketPacoca(media.path)}
                                                            alt={`comment-media-${index}`}
                                                            className="comment-image"
                                                        />
                                                    ) : (
                                                        <video
                                                            src={getImagePathBucketPacoca(media.path)}
                                                            controls
                                                            className="comment-video"
                                                        />
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div className="icons-config-comment user-select-none">
                                    <div className="response-icon-comment">
                                        {commentSelected?.total_responses} <MessageCircle className="icon-comment-response" data-feather="message-circle" />
                                    </div>
                                    <div className="response-icon-comment cursor-pointer" onClick={() => handleLike(commentSelected?.id ?? 0, true, commentSelected.id_comment)}>
                                        {commentSelected?.total_likes} <Heart className={`${commentSelected?.is_liked ? 'icon-heart-comment-liked' : ''} icon-heart-comment icon-comment-response`} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}

                    {error404 ? (
                        <div className="user-select-none row row-empty-comment" onClick={handleBlurTextarea}>
                            <span className="span-empty">
                                <Trash className="icon-empty" />
                                <h3 className="w-100 text-center">{error404}</h3>
                            </span>
                        </div>
                    ) : (
                            
                        <>
                            {isLoading || isLoadingPost ? (
                                <div className="row user-select-none row-empty" style={{ paddingTop: 0 }}>
                                    <CommentsPlaceholder loading={loading || isLoadingPost}/>
                                </div>
                            ) : (

                                <>
                                    {isLoadingPost ? (
                                        <div className="user-select-none row row-empty-comment" style={{ paddingTop: 160 }}>
                                            <span className="span-empty">
                                                <Trash className="icon-empty" />
                                                <h3 className="w-100 text-center">Essa publicação foi apagada</h3>
                                            </span>
                                        </div>
                                    ) : !isAuthenticated ? (
                                        <>
                                            <div className="row user-select-none row-empty" style={{ paddingTop: 160 }}>
                                                <span className="span-empty cursor-pointer">
                                                    <LogIn className="icon-empty" data-feather="heart" />
                                                    <h3 className="w-100 text-center">Faça login</h3>
                                                </span>
                                            </div>
                                        </>
                                    ) : !isLoadingPost && comments.length === 0 ? (
                                        <div className="row user-select-none row-empty" style={{ paddingTop: 160 }}   >
                                            <span className="span-empty">
                                                <MessageCircle className="icon-empty" data-feather="heart" />
                                                <h3 className="w-100 text-center">Seja o primeiro a {idCommentSelected ? "responder" : "comentar"}</h3>
                                            </span>
                                        </div>
                                    ) : (
                                    
                                        <>
                                            {[...comments].sort((a, b) => {
                                                const aPin = pinnedCommentIds.includes(a.id) ? 1 : 0;
                                                const bPin = pinnedCommentIds.includes(b.id) ? 1 : 0;
                                                return bPin - aPin;
                                            }).map((comment: Comment, index) => (

                                                <div key={index} className="div-comment" style={{ display: "flex", flexDirection: "column", position: "relative", marginLeft: commentSelected ? 20 : 0, opacity: comment.idNotSend ? (comment.idNotSend === "error" ? 0.4 : 0.5) : (comment.is_hidden ? .7 : 1), transition: "opacity 0.3s", pointerEvents: comment.idNotSend ? "none" : "auto" }}>
                                                    <div key={comment.id} className="row card-comment card-comment-modal" id="start-here">
                                                    <img
                                                        src={comment.user.img_account ? (BUCKET_PACOCA_URL + "/" + comment.user.img_account) : getImageUserNotFound(comment.user.name)} 
                                                        className={`user-select-none col-1 img-account-comment`} onError={(e) => { e.currentTarget.src = getImageUserNotFound(comment.user.name); }} />
                                                    {comment.user?.active_frame?.image_path &&
                                                        <Frame onClick={() => navigate(`/@${post?.user.user_name}`) } path={`${BUCKET_PACOCA_URL}/${comment.user.active_frame?.image_path}`} className="cursor-pointer comment"/>
                                                    }

                                                    <div className="col col-comment-text">
                                                        <div className="comment-text">
                                                            {comment.can_edit || comment.can_delete || comment.can_pin ? (
                                                                <div className="col-1 col-conf-comment" style={{ position: "absolute", zIndex: 1 }}>
                                                                    <AnchoredDropdown>
                                                                        {comment.can_edit ? (
                                                                            <DropdownItem icon={<Edit size={15} className="icon-config-post" />} onClick={() => clickEdit(comment.id, comment.textFormatted)}>
                                                                                Editar
                                                                            </DropdownItem>
                                                                        ) : null}
                                                                        {comment.can_delete ? (
                                                                            <DropdownItem icon={<Trash size={15} className="icon-config-post" />} danger onClick={() => handleDelete(comment.id)}>
                                                                                Excluir
                                                                            </DropdownItem>
                                                                        ) : null}
                                                                        {comment.can_pin ? (
                                                                            <PinComment
                                                                                commentId={comment.id}
                                                                                postOwnerId={post?.id_user ?? 0}
                                                                                isPinned={pinnedCommentIds.includes(comment.id)}
                                                                                onToggle={handlePinToggle}
                                                                            />
                                                                        ) : null}
                                                                    </AnchoredDropdown>
                                                                </div>
                                                            ) : null}

                                                            <div className="col-12 d-flex open-comment" style={{ gap: "5px", alignItems: "center", flexWrap: "wrap", }}>
                                                                <Link className="name-comment" to={`/@${comment.user.user_name}`}>
                                                                    {/* <span className="name-comment" onClick={() => comment.total_responses >0 ? toggleCommentExpansion(comment.id) : ""}> */}
                                                                    <h1 style={{ fontSize: "12.5px", marginBottom: 0 }}>
                                                                        <span>
                                                                            {comment?.user?.name || ''}
                                                                            <ImgVerified user={comment.user} classNameProp="img-verified-preview-comment user-select-none img-verificado-comentario" />
                                                                        </span>
                                                                        {comment?.user?.id == post?.user.id && <span className="author-comment" style={{ marginLeft: comment?.user.position || comment?.user?.stamps ? "20px" : "0" }}>autor</span>}
                                                                    </h1>
                                                                </Link>

                                                                {pinnedCommentIds.includes(comment.id) ? (
                                                                    <div title={t("post.pinnedCommentLabel")} style={{ display: "flex", alignItems: "center", color: "var(--primary-blue, #f59e0b)", fontSize: "11px", gap: "2px" }}>
                                                                        <Paperclip size={11} /> {t("post.pinnedCommentLabel")}
                                                                    </div>
                                                                ) : null}

                                                                {/* <div>
                                                                    <p className="date-comment" style={{ marginBottom: 0 }}>{calculateTime(comment.created_at)}</p>
                                                                </div> */}
                                                            </div>

                                                            {comment.textFormatted != comment.gif_url && (
                                                                <p className="text-comment open-comment" dangerouslySetInnerHTML={{ __html: renderTextWithPhoneMessageLinks(censorText(comment.textFormatted || ""), clearText) }}/>
                                                            )}
                                                            {!!comment.is_hidden && hasPosition(user) && (
                                                                <p className="text-comment open-comment" style={{ fontWeight: "bold" }} >Oculto pelo Paçoca AI por: {comment.hidden_reason}</p>
                                                            )}
                                                            
                                                            {!comment.gif_url && (
                                                                <>
                                                                    {/* YOUTUBE TEM PRIORIDADE */}
                                                                    {Boolean(extractYouTubeId(comment.textFormatted)) && (
                                                                        <YoutubePreview text={comment.textFormatted} />
                                                                    )}
                                                    
                                                                    {/* LINK PREVIEW SÓ SE NÃO FOR YOUTUBE */}
                                                                    {Boolean(!extractYouTubeId(comment.textFormatted)) && (
                                                                        <LinkPreview url={extractFirstUrl(comment.textFormatted) ?? ""}/>
                                                                    )}

                                                                </>
                                                            )}
                                                            {comment.gif_url && (
                                                                <img
                                                                    src={comment.gif_url}
                                                                    className="comment-gif"
                                                                    alt="GIF"
                                                                    style={{ marginTop: comment.textFormatted?.trim().length ? 0 : 5 }}
                                                                />
                                                            )}
                                                            
                                                            {comment?.images && comment.images.length > 0 && (
                                                                <div className="comment-media" style={{ marginTop: comment.textFormatted?.trim().length ? 0 : 5 }}>
                                                                    {comment.images.map((media, index) => (
                                                                        <div key={media.id ?? index} className="comment-media-item">
                                                                            {media.type == 0 ? (
                                                                                <img
                                                                                    onLoad={(e) => {
                                                                                        const img = e.currentTarget;
                                                                                        const diff = img.naturalWidth - img.naturalHeight;

                                                                                        if (Math.abs(diff) > 50 && img.naturalWidth > img.naturalHeight) {
                                                                                            // 2. The correct way to update one item in a React array
                                                                                            setOrientation((prev) => {
                                                                                                const newOrientation = [...prev]; // Make a copy of the old array
                                                                                                newOrientation[comment.id] = "horizontal"; // Update the index
                                                                                                return newOrientation;            // Return the new array
                                                                                            });
                                                                                        }
                                                                                    }}
                                                                                    onError={(e) => (e.currentTarget.src = "/img/image_not_found.png?v=1")}
                                                                                    src={media.isTemp ?  media.path : getImagePathBucketPacoca(media.path)}
                                                                                    alt={`comment-media-${index}`}
                                                                                    className={`comment-${comment.images && comment.images?.length <= 1 ? orientation[comment.id] : ""} comment-image`}
                                                                                />
                                                                            ) : (
                                                                                <video
                                                                                    src={getImagePathBucketPacoca(media.path)}
                                                                                    controls
                                                                                    className="comment-video"
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}


                                                        </div>
                                                            <div className="icons-config-comment user-select-none" style={{ marginBottom: 10 }}>
                                                                <div className="response-icon-comment cursor-pointer mt-1 d-flex" style={{ fontSize: "12px", alignItems: "center" }}>
                                                                    {calculateTimeReduce(comment.created_at)}
                                                                </div>
                                                                <div className="response-icon-comment">
                                                                    {comment.total_responses} <MessageCircle className="icon-comment-response" data-feather="message-circle" />
                                                                </div>
                                                                <div className="response-icon-comment cursor-pointer" onClick={() => handleLike(comment.id)}>
                                                                    {comment.total_likes} <Heart className={`${comment.is_liked ? 'icon-heart-comment-liked' : ''} icon-heart-comment icon-comment-response`} />
                                                                </div>
                                                                <div onClick={() => { setIdCommentToResponse(comment.id); setUserNameCommentToResponse(comment.user.name.split(" ")[0]); textareaRef.current?.focus() }} className="response-icon-comment cursor-pointer mt-1 d-flex" style={{ fontSize: "12px", alignItems: "center" }}>
                                                                    Responder
                                                                </div>
                                                            </div>
                                                    </div>
                                                </div>

                                                {comment.total_responses > 0 && !comment.responses ? (
                                                    <div className="user-select-none cursor-pointer text-loading-comments" onClick={() => toggleCommentExpansion(comment.id)}>
                                                        {isLoadingResponse == comment.id ? (
                                                            <LoadingThreeCircle size="7px" style={{justifyContent: "end"}}/>
                                                            // <Spinner className="text-primary" />
                                                        ) : (
                                                            <>Carregar respostas</>
                                                        )}
                                                    </div>
                                                ) : null}

                                                {expandedComments[comment.id] && comment.responses && (
                                                    <div className="" style={{position: "relative"}}>
                                                        
                                                        
                                                        {comment.responses.map((originalComment: any, index: number) => (
                                                            <div id="original-coment" key={index} className="responses-container row card-comment-open original-coment" style={{ marginTop: "5px", paddingTop: "0px", borderRadius: "10px", position: "relative", opacity: originalComment.idNotSend ? 0.5 : 1, transition: "opacity 0.3s", pointerEvents: originalComment.idNotSend ? "none" : "auto" }}>
                                                                    <div style={{position: "absolute"}}>
                                                                    <div id={index == 0 ? `line-follow-comment-vertical2-first` : "line-follow-comment-vertical2"}></div>
                                                                    <div id="line-follow-comment-horizontal2"></div>
                                                                </div>

                                                                <img className="user-select-none col-1 img-account-likes img-account-comment" src={getImageUser(originalComment?.user?.img_account)} onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} />
                                                                {/* <div className="col-1 img-account-likes img-account-comment img-account-search img-account-view-search" style={{ backgroundImage: `url("${getImageUser(originalComment?.user?.img_account)}")` }}></div> */}
                                                                <div className="col col-comment-text">
                                                                    <div className="comment-text">
                                                                
                                                                        {originalComment.can_edit || originalComment.can_delete ? (
                                                                            <div className="col-1 col-conf-post" style={{ position: "absolute", zIndex: 1 }}>
                                                                                <AnchoredDropdown>
                                                                                    {originalComment.can_edit ? (
                                                                                        <DropdownItem icon={<Edit size={15} className="icon-config-post" />} onClick={() => clickEdit(originalComment.id, originalComment.textFormatted)}>
                                                                                            Editar
                                                                                        </DropdownItem>
                                                                                    ) : null}
                                                                                    {originalComment.can_delete ? (
                                                                                        <DropdownItem icon={<Trash size={15} className="icon-config-post" />} danger onClick={() => handleDelete(originalComment.id, true, originalComment.id_comment)}>
                                                                                            Excluir
                                                                                        </DropdownItem>
                                                                                    ) : null}
                                                                                </AnchoredDropdown>
                                                                            </div>
                                                                        ) : null}

                                                                        <div className="col-12 d-flex" style={{ gap: "5px", alignItems: "center", flexWrap: "wrap" }}>
                                                                            <Link className="name-comment user-name-view-comment" to={`/@${originalComment?.user.user_name}`}>
                                                                                <h1 style={{ fontSize: "12.5px", marginBottom: 0 }}>
                                                                                    <span>
                                                                                        {originalComment?.user.name}
                                                                                        <ImgVerified user={originalComment.user} classNameProp="img-verified-preview-comment user-select-none img-verificado-comentario" />
                                                                                    </span>
                                                                                    {originalComment?.user?.id == post?.user.id && <span className="author-comment" style={{ marginLeft: originalComment?.user.position || originalComment?.user?.stamps?.includes("blue") ? "20px" : "0" }}>autor</span>}
                                                                                </h1>
                                                                            </Link>
                                                                            <div>
                                                                                <p className="date-comment date-comment-view-comment" style={{ marginBottom: 0 }}></p>
                                                                                {/* <p className="username-comment username-view-comment w-100">@{originalComment?.user.user_name}</p> */}
                                                                            </div>
                                                                        </div>
                                                                        {/* {!originalComment.gif_url && ( */}
                                                                            <p dangerouslySetInnerHTML={{ __html: renderTextWithPhoneMessageLinks(censorText(originalComment.textFormatted || ""), clearText) }} className="text-comment text-comment-view-comment cursor-pointer"/>
                                                                        {/* )} */}
                                                                        {originalComment.gif_url && (
                                                                            <img
                                                                                src={originalComment.gif_url}
                                                                                className="comment-gif"
                                                                                alt="GIF"
                                                                            />
                                                                        )}
                                                                        {originalComment?.images && originalComment.images.length > 0 && (
                                                                            <div className="comment-media">
                                                                                {originalComment.images.map((media: any, index: number) => (
                                                                                    <div key={media.id ?? index} className="comment-media-item">
                                                                                        {media.type == 0 ? (
                                                                                            <img
                                                                                                onError={(e) => (e.currentTarget.src = "/img/image_not_found.png?v=1")}
                                                                                                src={media.isTemp ?  media.path : getImagePathBucketPacoca(media.path)}
                                                                                                alt={`comment-media-${index}`}
                                                                                                className="comment-image"
                                                                                            />
                                                                                        ) : (
                                                                                            <video
                                                                                                src={getImagePathBucketPacoca(media.path)}
                                                                                                controls
                                                                                                className="comment-video"
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                        {/* <p dangerouslySetInnerHTML={{ __html: renderTextWithPhoneMessageLinks(censorText(originalComment.textFormatted || " a"), clearText) }} className="text-comment text-comment-view-comment cursor-pointer">

                                                                        </p> */}
                                                                    </div>
                                                                    <div className="icons-config-comment user-select-none">
                                                                        <div className="response-icon-comment cursor-pointer mt-1 d-flex" style={{ fontSize: "12px", alignItems: "center" }}>
                                                                            {calculateTimeReduce(originalComment.created_at)}
                                                                        </div>
                                                                        <div className="response-icon-comment">
                                                                            {originalComment?.total_responses} <MessageCircle className="icon-comment-response" data-feather="message-circle" />
                                                                        </div>
                                                                        <div className="response-icon-comment cursor-pointer" onClick={() => handleLike(originalComment?.id ?? 0, true, originalComment.id_comment)}>
                                                                            {originalComment?.total_likes} <Heart className={`${originalComment?.is_liked ? 'icon-heart-comment-liked' : ''} icon-heart-comment icon-comment-response`} />
                                                                        </div>
                                                                        <div onClick={() => { setOffset(0); setIdCommentSelected(originalComment.id); setCommentSelected(originalComment); setUserNameCommentToResponse(originalComment.user.name.split(" ")[0]); }} className="response-icon-comment cursor-pointer mt-1 d-flex" style={{ fontSize: "12px", alignItems: "center" }}>
                                                                            Respostas
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {comment.responses && comment.total_responses > comment?.responses?.length ? (
                                                    <div className="user-select-none cursor-pointer text-loading-comments">
                                                        {isLoadingResponse == comment.id ? (
                                                            <LoadingThreeCircle/>
                                                            // <Spinner className="text-primary" />
                                                        ) : (
                                                            <div onClick={() => loadResponses(comment.id, responsesOffset[comment.id] || 0)}>Carregar mais</div>
                                                        )}
                                                    </div>
                                                ) : null}
                                            </div>

                                            
                                        ))}

                                        {isLoadingMore ? (
                                            <div className="row user-select-none row-empty" style={{ paddingTop: 0 }}>
                                                <CommentsPlaceholder loading={loading || isLoadingPost}/>
                                            </div>
                                        ) : null}
                                    </>
                                )}

                            </>
                        )}
                        </>
                    )}
                </div>
            </div>

            <div className="modal-footer modal-footer-comment user-select-none" style={{ paddingBottom: bottomPadding, background: "var(--background-feed)", bottom: 0 }}>
                <div className="row row-comment" id="row-comment-{{$post?->id}}" style={{ width: "100%" }}>
                    <div className="col col-comment">
                        {!error404 ? (
                            <form ref={formRef} className="form-comment" onSubmit={(e) => e.preventDefault()}>
                                {user?.email_verified_at ? (
                                    <div className="d-flex" style={{ flexDirection: "column" }}>
                                        {aiLimitBannerName ? <AiLimitBanner aiName={aiLimitBannerName} /> : null}
                                        {idCommentToResponse ? (
                                            <div className="response-user" style={{ bottom: bottomPadding + textareaHeight + (selectedFiles.length ? 70 : 0)  + (window.innerWidth <=850 ? 35 : 40) }}>
                                                <p>Respondendo @{userNameCommentToResponse} - <span style={{ fontWeight: 500, cursor: "pointer" }} onClick={cancelEdit}>Cancelar</span></p>
                                            </div>
                                        ) : null}
                                        <div style={{ display: "flex", width: "100%" }}>
                                            <div style={{ width: "100%" }}>
                                                <div style={{ display: "flex", width: "100%" }}>
                                                    <textarea
                                                        rows={1}
                                                        value={text}
                                                        ref={textareaRef}
                                                        className="textarea-a-emoji form-control text-comment me-2"
                                                        placeholder={placeholderText}
                                                        required
                                                        onChange={(e) => handleInputTextarea(e)}
                                                        onKeyDown={(e) => handleKeyDown(e)}
                                                        style={{ background: "transparent!important" }}
                                                        onPaste={handlePaste}
                                                        onDragOver={(e) => e.preventDefault()}
                                                    />
                                                </div>
                                                
                                                <EmojiPickerNative
                                                    show={showEmoji} 
                                                    setShow={setShowEmoji} 
                                                    onSelect={(emoji) => { 
                                                    setText(prev => prev + emoji);
                                                    // textareaRef.current?.focus()
                                                    }}  
                                                    handleClickGif={handleClickGif}
                                                    bottom={bottomPadding + textareaHeight + (window.innerWidth <=850 ? 35 : 40)}
                                                />
                                                <PreviewSearch 
                                                    textareaRef={textareaRef} 
                                                    text={text ?? ""} 
                                                    setText={setText}
                                                    bottom={bottomPadding + textareaHeight + (window.innerWidth <=850 ? 35 : 40)}
                                                />

                                                <div className={`row row-preview-img ${selectedFiles.length > 1 ? "row-preview-img-multiple" : ""}`}>
                                                    {selectedFiles.map((file, index) => (
                                                        <>
                                                            {file.type === "image" ? (
                                                                <div key={index} className="row-label-img-comment">
                                                                    <div className="btn-container-add-img" style={{ marginBottom: "5px", display: "flex", gap: "5px", position: "relative" }}>
                                                                        <button type="button" onClick={() => handleRemoveMedia(index)} className="btn-x-right btn-close svg-icons-color btn-dark" style={{ right: 0, top: 7 }}>
                                                                            <X/>
                                                                        </button>
                                                                    </div>
                                                                    <img alt={`preview-${index}`} src={file.src} className="label-img img-preview-comment"/>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <div className="row row-label-video" style={{ margin: 0, height: "100%", minHeight: selectedFiles.length > 1 ? 300 : 250, overflow: "auto", position: "relative" }}>
                                                                        <button type="button" onClick={() => handleRemoveMedia(index)} className="btn-x-right btn-close svg-icons-color btn-dark">
                                                                            <X/>
                                                                        </button>

                                                                        <label className="label-img label-video" style={{ minHeight: selectedFiles.length > 1 ? 300 : 0 }} htmlFor="video">
                                                                            <ReactPlayer url={file.src} style={{ objectFit: "cover", minHeight: selectedFiles.length > 1 ? 300 : 250, maxHeight: selectedFiles.length > 1 ? 300 : 250 }} controls width="100%" className="video-preview" />
                                                                        </label>
                                                                    </div>    
                                                                </>
                                                            )}
                                                        </>
                                                    ))}
                                                </div>

                                                <div style={{ display: "flex", gap: 10 }}>
                                                    {!isEdditing && (
                                                        <div className="cursor-pointer div-emoji-chat" onClick={() => { fileInputRefComment.current?.click() }}>
                                                            <Images className="icon-comment-sticky"/>
                                                        </div>
                                                    )}
                                                    <div className="cursor-pointer div-emoji-chat" onClick={() => setShowEmoji(true)}>
                                                        <Laugh className="icon-comment-sticky"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <input type="file" ref={fileInputRefComment} multiple accept="image/*,video/*" onChange={handleMediaChange} style={{ position: "fixed", top: -10000, zIndex: 0 }} name='imgComment' id='imgComment' />

                                            <button style={{ borderRadius: "50%"}} onMouseDown={(e) => e.preventDefault()} onClick={handleSubmitComment} className="btn btn-blue-send-comment button-submit-comment" disabled={disabled}>
                                                <Send className="icon-send-comment" data-feather="send" />
                                            </button>

                                            {isEdditing ? (
                                                <button onClick={cancelEdit} className="btn btn-red-cancel-comment button-cancel-edit-comment" type="button" >
                                                    <XSquare className="icon-send-comment" data-feather="x-square" />
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        {isAuthenticated ? (
                                            <>
                                                <p style={{ marginBottom: 10 }}>Verifique o email para comentar</p>
                                                <FormVerifyEmail />
                                            </>
                                        ) : null}
                                    </>
                                )}
                            </form>
                        ) : null}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ModalCommentsContent;
